import * as React from 'react';
import { Grid } from '@material-ui/core';

import {
  ORGANIZATION_LIST_TYPE_BY,
} from '../../../constants';
import { FormSelect, FormTextField } from '../../../components';

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="organizations-filter-by-name"
      data-apim-test="organizations-filter-by-name"
    />
  </Grid>
);

export const FilterByType = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="organizations-filter-by-type"
      data-apim-test="organizations-filter-by-type"
      data={ORGANIZATION_LIST_TYPE_BY}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);



// WEBPACK FOOTER //
// ./src/pages/Organization/List/controls.js